export { default } from './ResponsiveHoc';
